var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{on:{"search":_vm.itemSearched}}),_c('main',[_c('Films',{attrs:{"passedInput":_vm.updateSearch}}),_c('Series',{attrs:{"passedInput":_vm.updateSearch}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }